import api from 'api/apiInstance';

export function userResendConfirmationApi(path: string) {
  return {
    path,
    POST: () => api.post(path),
  };
}
